export default "__VITE_ASSET__CUUSzcg5__"